import classNames from "classnames";

import css from "./calendar_date.module.scss";

export const getDayClass = (config, ...classes) =>
  classNames(
    css.day,
    {
      [css.today]: config.today,
      [css.prevBusy]: config.prevBusy,
      [css.nextBusy]: config.nextBusy,
      [css.hovered]: config.hovered,
      [css.disabled]: config.disabled,
      [css.selected]: config.selected,
      [css.keyboardSelected]: config.keyboardSelected,
      [css.readOnly]: config.readOnly,
      [css.notCurrentMonth]: config.notCurrentMonth,
      [css.offLimit]: config.offLimit
    },
    ...classes
  );
